import { action, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../../common/Api";
import { Division } from "../../domains/Division";
import { Region } from "../../domains/Region";
import { AdminStore } from "../AdminStore";
import { DivisionEditStore } from "./DivisionEditStore";
import { RegionEditStore } from "./RegionEditStore";

export class RegionsStore {
  rootStore: AdminStore;

  regions: Region[] = [];
  divisions: Division[] = [];
  loading = false;
  edit: RegionEditStore;
  editDivision: DivisionEditStore;

  constructor(rootStore: AdminStore) {
    makeAutoObservable(this, {
      rootStore: false,
    });
    this.rootStore = rootStore;
    // this.refresh();
    this.edit = new RegionEditStore(this);
    this.editDivision = new DivisionEditStore(this);
  }

  @action refresh() {
    this.loading = true;
    return Api.region
      .regions()
      .then((res) => {
        runInAction(() => {
          this.regions = res.data.regions.map((x) => {
            return {
              ...x,
              directors: (x.directors || []).length > 0 ? x.directors : [x.director],
              directorIds: (x.directorIds || []).length > 0 ? x.directorIds : [x.directorId],
            };
          });
          this.divisions = res.data.divisions.map((x) => {
            return {
              ...x,
              directors: (x.directors || []).length > 0 ? x.directors : [x.director],
              directorIds: (x.directorIds || []).length > 0 ? x.directorIds : [x.directorId],
            };
          });
        });
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
